import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Card, Tabs } from 'antd';
import VerificationCode from './VerificationCode';
import Password from './Password';
import ForgetPassword from './ForgetPassword';
import s from './style.m.less';
import InformationModal from '../CustomPage/qhb/InformationModal';
@inject('store')
@observer
class Home extends Component {
    onChange = (activeKey) => {
        const {
            store: { login }
        } = this.props;

        login.setActiveKey(activeKey);
    };
    onCancel = () => {
        window.location.reload();
    };
    render() {
        const {
            store: { login }
        } = this.props;

        return (
            <div className={s.app}>
                <InformationModal
                    onCancel={this.onCancel}
                    closable={true}
                    title={'完善注册信息'}
                    tip={'请您先完善下方的信息，即可完成注册'}
                ></InformationModal>
                <div className={s['app_logo']}></div>
                <div className={s['content_box']}>
                    <div className={s.content}>
                        {login.mode === 'login' ? (
                            <Card>
                                <h3 style={{ margin: '6px 0 12px', fontSize: '20px' }}>欢迎登录学习公社</h3>
                                <Tabs
                                    onChange={this.onChange}
                                    activeKey={login.activeKey}
                                    items={[
                                        {
                                            key: 'code',
                                            label: '验证码登录',
                                            children: <VerificationCode />
                                        },
                                        {
                                            key: 'password',
                                            label: '密码登录',
                                            children: <Password />
                                        }
                                    ]}
                                />
                            </Card>
                        ) : (
                            <Card>
                                <ForgetPassword />
                            </Card>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default Home;
